const ProductFeatures = function($selector) {
	const module = {
		opts: {
			$module: $selector,
			breakpoint: 768,
			selectors: {
				slider: '.product-features__slider',
				sliderNav: '.js-slider-controls',
				tabContent: '.product-features__groups',
				tabPanel: '.product-features__group',
				tabNav: '.product-features__nav',
				tab: '.product-features__nav .nav-link',
				hotspots: '.hotspots',
				hotspot: '.hotspot',
			}
		},
		data: {
			$activeTabPanel: {},
			$activeSlider: {},
			$activeHotspotPanel: {},
		},
		bindEvents: function() {
			// Tab shown
			this.opts.$module.find(this.opts.selectors.tab).on('shown.bs.tab', this.handleTabChange.bind(this));
			// Hotspot clicked
			this.opts.$module.find(this.opts.selectors.hotspot).on('click', this.handleHotspotClick.bind(this));
		},
		init: function() {
			// Bind any events we need
			this.bindEvents();

			// Kickoff main change event to initialize
			if ($(window).width() < this.opts.breakpoint) {
				this.initMobileSliders();
			} else {
				this.handleTabChange();
			}
		},
		handleTabChange: function(e = null) {
			let $activeTabPanel = e ? $(e.target) : this.opts.$module.find(`${this.opts.selectors.tabPanel}.active`);

			// If we have a tab change event
			if (e) {
				const target = $(e.target).data('bs-target')
				$activeTabPanel = $(target);
			}
			// Otherwise, setup default
			else {
				$activeTabPanel = this.opts.$module.find(`${this.opts.selectors.tabPanel}.active`);
			}

			// Save internal variables
			this.data.$activeTabPanel = $activeTabPanel;
			this.data.$activeSlider = $activeTabPanel.find(this.opts.selectors.slider);
			this.data.$activeHotspotPanel = $(`${this.opts.selectors.hotspots}[data-index="${$activeTabPanel.data('index')}"]`);

			// Trigger methods
			this.initSlider();
			this.initHotspots();
		},
		initSlider: function() {
			const _self = this;

			if (this.data.$activeSlider.hasClass('slick-initialized')) {
				return;
			}

			this.data.$activeSlider.each((i, el) => {
				const $slider = $(el);
				const $controls = $slider.next(_self.opts.selectors.sliderNav);
				const { nextArrow, prevArrow } = Globals.sliders;

				$slider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
					_self.data.$activeHotspotPanel.find(`${_self.opts.selectors.hotspot}[data-id="${nextSlide}"]`).addClass('active').siblings().removeClass('active');
				}).slick({
					nextArrow, // defined in scripts.js
					prevArrow, // defined in scripts.js
					dots: true,
					appendDots: $controls,
					appendArrows: $controls,
					infinite: false
				});
			});
		},
		initMobileSliders: function() {
			const _self = this;

			$(_self.opts.selectors.slider).each((i, el) => {
				const $slider = $(el);
				const $controls = $slider.next(_self.opts.selectors.sliderNav);
				const { nextArrow, prevArrow } = Globals.sliders;

				$slider.slick({
					nextArrow, // defined in scripts.js
					prevArrow, // defined in scripts.js
					dots: true,
					appendDots: $controls,
					appendArrows: $controls,
					slidesToShow: 1.25,
					infinite: false
				});
			});
		},
		initHotspots: function() {
			this.data.$activeHotspotPanel.addClass('active').siblings().removeClass('active');
		},
		handleHotspotClick: function(e) {
			const $hotspot = $(e.currentTarget);
			const targetSlide = $hotspot.data('id');

			$hotspot.addClass('active').siblings().removeClass('active');
			this.data.$activeSlider.slick('slickGoTo', targetSlide);
		}
	}

	if ($selector.length) {
		module.init();
	}

	return module;
}


/**
 * Register after jQuery doc ready
 */
$(() => {
	new ProductFeatures($('.block-product-features'));
});
